import "./footer.css";

import React from "react";
import { Link } from "react-router-dom";

import { CONTACT_DETAILS, LEGAL, ROUTES } from "../../data/content";

export const FacebookIcon = () => (
  <svg
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
  >
    <path d={"M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.26h3.33l-.53 3.49h-2.8V24C19.61 23.1 24 18.1 24 12.07z"} />
  </svg>
);

const Footer = () => {
  return (
    <footer className={"site-footer"}>
      <div className={"container"}>
        <div className={"footer-columns"}>
          <div className={"footer-column"}>
            <h2 className={"footer-heading"}>
              <Link to={ROUTES.CONTACT}>Contact Us</Link>
            </h2>
            <span className={"title-rule is-yellow footer-rule"} />
            <ul className={"footer-contact"}>
              {CONTACT_DETAILS.PHONES.map((phone) => (
                <li key={phone.link}>
                  <a href={phone.link}>{phone.label}</a>
                </li>
              ))}
              <li>
                <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
              </li>
            </ul>
          </div>

          <div className={"footer-column footer-brand"}>
            <Link
              to={ROUTES.HOME}
              className={"footer-logo"}
            >
              <img
                src={"/images/logo-round.png"}
                alt={"about U Financial Advisors - Discovery"}
                width={240}
                height={231}
                loading={"lazy"}
              />
            </Link>
            <Link
              to={`${ROUTES.CONTACT}#map`}
              className={"footer-map-link"}
            >
              VIEW MAP
            </Link>
          </div>

          <div className={"footer-column"}>
            <h2 className={"footer-heading"}>Follow Us</h2>
            <span className={"title-rule is-yellow footer-rule"} />
            <a
              href={CONTACT_DETAILS.FACEBOOK_LINK}
              className={"footer-social"}
              target={"_blank"}
              rel={"noopener noreferrer"}
              aria-label={"about U on Facebook"}
            >
              <FacebookIcon />
            </a>
          </div>
        </div>

        <p className={"footer-legal"}>{LEGAL.COMPANY}</p>

        <ul className={"footer-policies"}>
          {LEGAL.POLICIES.map((policy) => (
            <li key={policy.link}>
              <a
                href={policy.link}
                target={"_blank"}
                rel={"noopener noreferrer"}
              >
                {policy.label}
              </a>
            </li>
          ))}
        </ul>

        <p className={"footer-copyright"}>
          © {new Date().getFullYear()} about U. Proudly created by{" "}
          <a
            href={"https://www.tap-x.com/"}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            TapX
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
